//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Epk.WebControls.OveritPodpisy.ts						</Name>
//    <Description> Podrobnosti - Historie schvalování dokumentu				</Description>
//    <Author>      thazmuka													</Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2018							</Copyright>
//    <Created>     2018-07-25													</Created>
//  </FileHeader>

namespace Gordic.Epk.WebControls {

	const { gcontent } = Decorators;

	/** K vyřízení */
	@gcontent
	export class HistSchvalDokument extends GContentBase {

		/** identifikátor */
		private Ixp: string;
		/** grid element */
		private grid: JQuery<HTMLElement>;


		public onContentReady(): void {
			console.log('Dialog "Historie schvalování dokumentu" je připraven.');
			this.init();
		}

		private init(): void {
			this.createMenubar();
			this.createCommandbar();
			this.createGrid();
		}

		/** vytvoření seznamu */
		private createGrid() {

			this.grid = $("<div>").appendTo(this.element);

			this.grid
				.gautofit({
					parentElement: this.element
				})
				.ggrid({
					name: "GridHistorieZmenZadosti",
					renderMode: "auto",
					columnMode: "full",
					customClass: "js-grid-historie-zmen-zadosti",
					navigationMode: "row",
					searchColumns: ["dat_zmena", "zmena_txt", "poznamka", "nazev_rf"],
					columns: this.loadGridFormat(),
				});

			this.refreshHistorieZmenZadosti();
		}

		/** nasetování dat do gridu historie změn žádosti */
		private setDataToGridHistorieZmenZadosti() {

			let dfd = $.Deferred();

			this.call("GetSeznamHistorieZmenZadosti", { Ixp: this.Ixp }).done((dto) => {
				var view = new Gordic.Data.View(dto);		//key je dulezity kvuli pripadnemu vyhledavani radku
				this.grid.ggrid("setData", view, true);		//true = prekresleni gridu
				dfd.resolve();
			});

			return dfd.promise();
		}

		/** občerstvení seznamu historie změn žádosti - nasetování dat do seznamu */
		private refreshHistorieZmenZadosti() {
			this.setDataToGridHistorieZmenZadosti();
		}

		/** načtení sloupců gridu historie změn žádosti */
		private loadGridFormat(): Gordic.Data.GridFormat {

			var gridColumnsDefinition = new Gordic.Data.GridFormat();

			gridColumnsDefinition
				.addDateTimeColumn({
					name: "dat_zmena",
					caption: "jres:26265060",	//RC 26265060 : Datum změny
					width: 150,
				})
				.addTextColumn({
					name: "zmena_txt",
					caption: "jres:32000020",	//RC 32000020 : Změna
					width: 600,
				})
				.addTextColumn({
					name: "poznamka",
					caption: "jres:32000021",	//RC 32000021 : Poznámka
					width: 150,
				})
				.addTextColumn({
					name: "nazev_rf",
					caption: "jres:32000017",	//RC 32000017 : Změnu provedl
					width: 250,
				})

			return gridColumnsDefinition;

		}

		private createMenubar() {

			let refreshButton = {
				icon: "gi-refresh",
				caption: "jres:32000022", //RC 32000022 : Občerstvit
				align: "opposite",
				run: () => {
					this.refreshHistorieZmenZadosti();
				}
			}

			let barActions = new GActionList({
				actRefresh: refreshButton
			});

			this.menuBar(barActions.createBar(["actRefresh*"]));

		}

		private createCommandbar() {

			let zavrit = {
				caption: "jres:32000023", //RC 32000023 : Zavřít
				align: "opposite",
				run: () => {
					this.tryClose();
				}
			}

			let barActions = new GActionList({
				actZavrit: zavrit
			});

			this.commandBar(barActions.createBar(["actZavrit*"]));

		}


	}
}

